import innerRoutes from './modules/inner'
import outwardRoutes from './modules/outward'
import settle from './modules/settle'

const asyncRoutes = [
  // 汇入汇款
  innerRoutes,
  // 汇出汇款
  outwardRoutes,
  // 欧美电商提款
  settle
]

export default asyncRoutes
